import { z } from 'zod';
export var FlowRunBlockMetricTypeFilter;
(function (FlowRunBlockMetricTypeFilter) {
    /** Only return billable metrics, as defined by the m3ter rate card applicable to the organization */
    FlowRunBlockMetricTypeFilter["Billable"] = "Billable";
})(FlowRunBlockMetricTypeFilter || (FlowRunBlockMetricTypeFilter = {}));
export const FlowRunBlockMetricFindAllParamsSchema = z.object({
    flowRunId: z.string(),
    metricTypeFilter: z.enum(FlowRunBlockMetricTypeFilter).optional(),
});
//# sourceMappingURL=blockMetric.js.map